import { useEffect, useState } from "react";
import styled from "styled-components";
import { styled as muiStyled } from "@mui/material/styles";
import { useSnackbar } from "notistack";

import { Grid } from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";

import CloseIcon from "@mui/icons-material/Close";

import { updateStatusCancelRefund } from "src/api/purchaseOrder";

import font from "src/styles/font";
import device from "src/styles/device";
import { Black, DarkGrey, White01 } from "src/styles/color";

import Dialog from "src/components/core/Dialog";
import Button from "src/components/core/Button";
import TextField from "src/components/core/TextField";
import CancelMessage from "src/modules/order/purchase-order/modal/component/CancelMessage";
import { checkNotEmpty } from "src/common";

const CloseButton = styled(IconButton)`
  &.MuiIconButton-root {
    position: absolute;
    top: 16px;
    right: 16px;
    color: ${Black};
  }
`;

const SpanTitle = styled.div`
  font-size: ${font.size.md};
  font-weight: 600;
  line-height: 24px;
  margin-bottom: ${({ mb }) => (mb ? `${mb}px` : 0)};

  @media ${device.mobileL} {
    font-size: ${font.size.sm};
  }
`;

const SpanLabel = styled.div`
  font-size: ${font.size.md};
  font-weight: 400;
  line-height: 24px;

  @media ${device.mobileL} {
    font-size: ${font.size.sm};
  }
`;

const SpanRemark = styled.div`
  font-size: ${font.size.sm};
  font-weight: 400;
  line-height: 24px;
  color: ${DarkGrey};

  @media ${device.mobileL} {
    font-size: ${font.size.xs};
  }
`;

const WrapperBox = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media ${device.mobileL} {
    /* flex-direction: column;
    align-items: flex-start;
    gap: 4px; */

    /* .MuiFormControl-root {
      width: 100%;
      min-width: unset;
      max-width: unset;
      min-height: 40px;
    } */
  }
`;

const WrapperPrice = styled.div`
  width: max-content;
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  gap: 16px;

  .MuiTextField-root {
    max-width: 200px;
  }
  .MuiOutlinedInput-input {
    text-align: right;
  }

  @media ${device.mobileL} {
    /* flex-direction: column;
    align-items: flex-start;
    gap: 4px; */

    /* .MuiFormControl-root {
      width: 100%;
      min-width: unset;
      max-width: unset;
      min-height: 40px;
    } */
  }
`;

const StyledTextField = styled(TextField)`
  .MuiInputBase-adornedEnd {
    padding-right: 2px;
  }

  /* read-only */
  .MuiInputBase-root.Mui-readOnly {
    background-color: ${White01};
  }
`;

const StyledDialog = muiStyled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 16,
  },
  "& .MuiDialogContent-root": {
    maxHeight: "500px",
    border: 0,
    padding: 24,
    paddingTop: 0,
  },
  "& .MuiDialog-container": {
    "& .MuiPaper-root": {
      width: "100%",
      maxWidth: 640,
    },
  },
  "& .MuiDialogActions-root": {
    justifyContent: "center",
    padding: 24,
  },
  "& .MuiDialogActions-root>:not(:first-of-type)": {
    marginLeft: 24,
  },

  [theme.breakpoints.down("sm")]: {
    "& .MuiPaper-root": {
      margin: 24,
    },
    "& .MuiDialogContent-root": {
      padding: 16,
      paddingTop: 0,
    },
    "& .MuiDialogActions-root": {
      padding: 16,
    },
  },
}));

const CancelRefundDialog = ({
  orderDetail,
  onClose,
  onSuccess,
  setIsLoading,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  // !! waiting for REAL model
  const defaultData = {
    cancelMessage: "",
    total: 0,
    remark: "",
  };
  const [updateOrder, setUpdateOrder] = useState(defaultData);

  useEffect(() => {
    if (!orderDetail) return;

    setUpdateOrder({
      ...defaultData,
      total: orderDetail?.totalVat,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderDetail]);

  const isFormValid = ["cancelMessage", "total"].every((required) => {
    let objVal = updateOrder[required];
    return checkNotEmpty(objVal);
  });

  const onSubmit = async () => {
    try {
      setIsLoading(true);
      const updateParams = {
        ...updateOrder,
      };

      const result = await updateStatusCancelRefund(
        orderDetail?._id,
        updateParams,
      );
      enqueueSnackbar(`Cancel Order Success!`, {
        variant: "success",
      });
      await onSuccess(result.data.refundId);
    } catch (err) {
      console.error("err:", err.response);
      enqueueSnackbar(err.response.data.message, {
        variant: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <StyledDialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={true}
    >
      <DialogTitle
        sx={{
          p: {
            sm: 3,
            xs: 2,
          },
          display: "flex",
          alignItems: "center",
          gap: 1,
          fontSize: {
            sm: font.size.lg,
            xs: font.size.md,
          },
          fontWeight: 600,
        }}
      >
        ยกเลิกและคืนเงิน
        <CloseButton aria-label="close" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </CloseButton>
      </DialogTitle>

      <DialogContent>
        <Grid container spacing={{ sm: 3, xs: 2 }}>
          <Grid item xs={12}>
            <SpanTitle>สาเหตุที่ยกเลิก</SpanTitle>
          </Grid>

          <Grid item xs={12}>
            <CancelMessage
              updateOrder={updateOrder}
              setUpdateOrder={setUpdateOrder}
            />
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>

          {/* <Grid item xs={12}>
            <SpanTitle>จำนวนเงินที่คืน</SpanTitle>
          </Grid>

          <Grid container item xs={12} spacing={2}>
            <Grid item xs={12}>
              <WrapperBox>
                <SpanLabel>ราคาสินค้า</SpanLabel>

                <WrapperPrice>
                  <StyledTextField
                    variant="outlined"
                    fullWidth
                    onChange={(e) => {
                      setUpdateOrder({
                        ...updateOrder,
                        totalPrice: e.target.value,
                      });
                    }}
                    value={updateOrder.totalPrice}
                    // error={!!formErrors[`promo_start_time`]}
                    // helperText={
                    //   !!formErrors[`promo_start_time`]
                    //     ? formErrors[`promo_start_time`].message
                    //     : ""
                    // }
                  />
                  <SpanLabel>บาท</SpanLabel>
                </WrapperPrice>
              </WrapperBox>
            </Grid>

            <Grid item xs={12}>
              <WrapperBox>
                <SpanLabel>ราคาช่าง</SpanLabel>

                <WrapperPrice>
                  <StyledTextField
                    variant="outlined"
                    fullWidth
                    onChange={(e) => {
                      setUpdateOrder({
                        ...updateOrder,
                        totalInstaller: e.target.value,
                      });
                    }}
                    value={updateOrder.totalInstaller}
                    // error={!!formErrors[`promo_start_time`]}
                    // helperText={
                    //   !!formErrors[`promo_start_time`]
                    //     ? formErrors[`promo_start_time`].message
                    //     : ""
                    // }
                  />
                  <SpanLabel>บาท</SpanLabel>
                </WrapperPrice>
              </WrapperBox>
            </Grid>

            <Grid item xs={12}>
              <WrapperBox>
                <SpanLabel>ภาษี 7%</SpanLabel>

                <WrapperPrice>
                  <StyledTextField
                    variant="outlined"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    // onChange={(e) => {
                    //   setUpdateOrder({
                    //     ...updateOrder,
                    //     totalVat: e.target.value,
                    //   });
                    // }}
                    value={updateOrder.totalVat}
                    // error={!!formErrors[`promo_start_time`]}
                    // helperText={
                    //   !!formErrors[`promo_start_time`]
                    //     ? formErrors[`promo_start_time`].message
                    //     : ""
                    // }
                  />
                  <SpanLabel>บาท</SpanLabel>
                </WrapperPrice>
              </WrapperBox>
            </Grid>

            <Grid item xs={12}>
              <WrapperBox>
                <SpanLabel>ค่าจัดส่ง</SpanLabel>

                <WrapperPrice>
                  <StyledTextField
                    variant="outlined"
                    fullWidth
                    onChange={(e) => {
                      setUpdateOrder({
                        ...updateOrder,
                        totalDelivery: e.target.value,
                      });
                    }}
                    value={updateOrder.totalDelivery}
                    // error={!!formErrors[`promo_start_time`]}
                    // helperText={
                    //   !!formErrors[`promo_start_time`]
                    //     ? formErrors[`promo_start_time`].message
                    //     : ""
                    // }
                  />
                  <SpanLabel>บาท</SpanLabel>
                </WrapperPrice>
              </WrapperBox>
            </Grid>

            <Grid item xs={12}>
              <WrapperBox>
                <SpanLabel>ราคารวมทั้งหมด</SpanLabel>

                <WrapperPrice>
                  <SpanLabel>{updateOrder.totalAll}</SpanLabel>
                  <SpanLabel>บาท</SpanLabel>
                </WrapperPrice>
              </WrapperBox>
            </Grid>
          </Grid> */}

          <Grid item xs={12}>
            <WrapperBox>
              <SpanLabel>จำนวนเงินที่คืน</SpanLabel>

              <WrapperPrice>
                <StyledTextField
                  variant="outlined"
                  fullWidth
                  onChange={(e) => {
                    setUpdateOrder({
                      ...updateOrder,
                      total: e.target.value,
                    });
                  }}
                  value={updateOrder.total}
                  error={!checkNotEmpty(updateOrder.total)}
                  // helperText={
                  //   !!formErrors[`promo_start_time`]
                  //     ? formErrors[`promo_start_time`].message
                  //     : ""
                  // }
                />
                <SpanLabel>บาท</SpanLabel>
              </WrapperPrice>
            </WrapperBox>
          </Grid>

          <Grid item xs={12}>
            <SpanTitle mb={8}>หมายเหตุ</SpanTitle>

            <StyledTextField
              variant="outlined"
              fullWidth
              multiline
              rows={3}
              onChange={(e) => {
                setUpdateOrder({
                  ...updateOrder,
                  remark: e.target.value,
                });
              }}
              value={updateOrder.remark}
              placeholder="กรณียอดคืนไม่ตรงกับยอดชำระ กรุณาระบุเหตุผลในช่องหมายเหตุ"
            />
          </Grid>

          <Grid item xs={12}>
            <SpanRemark>
              - ชื่อบัญชีที่รับเงินคืนจะต้องเป็นชื่อเดียวกับชื่อที่โอนเข้า
              บริษัทฯเท่านั้น
            </SpanRemark>
            <SpanRemark>- ใช้เวลาดำเนินการ 7-14 วันทำการ</SpanRemark>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button
          variant="outlined"
          color="secondary"
          size="large"
          onClick={() => onClose()}
          sx={{
            width: "100%",
            maxWidth: 180,
          }}
        >
          ยกเลิก
        </Button>

        <Button
          variant="contained"
          size="large"
          onClick={() => onSubmit()}
          disabled={!isFormValid}
          // disabled={true} // !! for hold refund flow (delete this and uncomment previous line)
          sx={{
            width: "100%",
            maxWidth: 180,
          }}
        >
          ยืนยัน
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

export default CancelRefundDialog;
